/* @ngInject */
export default class ResourceService {
  constructor($q, $sails) {
    this.$sails = $sails;
    this.$q = $q;
  }

  destroy(resourcelistId, resourceId) {
    return this.$sails.delete(`/resourcelist/${resourcelistId}/resource/${resourceId}`);
  }

  update(resourcelistId, resourceId, resourceUpdates) {
    return this.$sails.put(`/resourcelist/${resourcelistId}/resource/${resourceId}`, resourceUpdates);
  }

  create(resourcelistId, newResource) {
    return this.$sails.post(`/resourcelist/${resourcelistId}/resource`, newResource);
  }

}
